import React from "react";
import Icon from "../Icon/Icon";
import Button from "./Button";
import PropTypes from "prop-types";
import Svg from "../Icon/Svg";

const IconButton = ({
  appearance = "none",
  iconType = "icon",
  icon,
  iconSize = "small",
  title,
  notification = null,
  type = "button",
  format = "square",
  size = "default",
  ...props
}) => {
  return (
    <Button
      {...props}
      appearance={appearance ? `icon-${appearance}` : "icon"}
      title={title}
      type={type}
      format={format}
      size={size}
    >
      {iconType === "svg" ? (
        <Svg type={icon} size={iconSize} />
      ) : (
        <Icon icon={icon} size={iconSize} title={title} />
      )}
    </Button>
  );
};

IconButton.propTypes = {
  title: Icon.propTypes.title,
  icon: Icon.propTypes.icon,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  notification: PropTypes.any,
  format: PropTypes.string,
  appearance: PropTypes.string,
  type: PropTypes.string,
};

export default IconButton;
